export default __webpack_public_path__ + "static/media/person.1e536266.svg";